import { render, staticRenderFns } from "./LookKPIScoreList.vue?vue&type=template&id=35548b76&scoped=true&"
import script from "./LookKPIScoreList.vue?vue&type=script&lang=js&"
export * from "./LookKPIScoreList.vue?vue&type=script&lang=js&"
import style0 from "./LookKPIScoreList.vue?vue&type=style&index=0&id=35548b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35548b76",
  null
  
)

export default component.exports